var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormidlingAfFortidsminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.455,7.248l6.513.015a1.22,1.22,0,0,0,1.2-1.282l-.021-.627a1.211,1.211,0,0,0-1.305-1.189l-6.492.611a1.241,1.241,0,0,0,.106,2.472Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.009,9.86l-.746-1.287a1.132,1.132,0,0,0-.982-.55H10.92A1.08,1.08,0,0,0,9.815,9.257l.224,1.287a1.105,1.105,0,0,0,1.106.887h.882A1.062,1.062,0,0,0,13.009,9.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.889,8.023H3.948a.831.831,0,0,0-.632.3L2.107,9.743a.983.983,0,0,0,.6,1.626l1.512.062a.864.864,0,0,0,.817-.548L5.674,9.4A.962.962,0,0,0,4.889,8.023Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.084,8.158H7.65a1.022,1.022,0,0,0-1,.949l-.1,1.189a1.028,1.028,0,0,0,1,1.135H7.98a1.021,1.021,0,0,0,1-.948l.1-1.189A1.029,1.029,0,0,0,8.084,8.158Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormidlingAfFortidsminder);
export default __webpack_public_path__ + "static/media/FORMIDLING-AF-FORTIDSMINDER.4419c6a0ef325ba0ddce4d93d804af0e.svg";
export { ForwardRef as ReactComponent };